<template>
  <!-- <div> -->

  <Col :span="4" >
    <div class="order-item" @click="toPage">
      <div class="title">{{ title }}</div>
      <div class="num">{{ num || '0' }}</div>
    </div>
</Col>
<!-- </div> -->

</template>

<script>
export default {
  name: 'order',
  props: {
    title: String,
    id:[String,Number],
    num: Number
  },
  created() {
    console.log(this.num,this.id,'num');
  },
  methods:{
   toPage(){
     localStorage.setItem('order_status', this.id)
     this.$router.push({ name: 'order_list' ,params:{id:this.id}})
   },
  }

}
</script>

<style scoped lang="less">
.order-item {
  // width: 30%;
  min-width: 100px;
  margin-left: 5px;
  margin-right: 5px;
  height: 90px;
  border-radius: 12px;
  background-color: rgb(247, 248, 250);
  padding: 12px 18px;
  margin-bottom: 10px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;

  .title {
    font-size: 12px;
    color: rgb(102, 102, 102);
    letter-spacing: 0;
    line-height: 1;
    text-align: center;
  }

  .num {
    font-size: 28px;
    color: rgb(17, 17, 17);
    letter-spacing: 0;
    line-height: 1;
    margin-top: 5px;
    text-align: center;
  }
}
</style>
